module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-snackbar mdl-js-snackbar",
    attrs: {
      "aria-live": "assertive",
      "aria-atomic": "true",
      "aria-relevant": "text"
    }
  }, [_c('div', {
    staticClass: "mdl-snackbar__text"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-snackbar__action",
    attrs: {
      "type": "button"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96cfc822","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Snackbar/index.vue
// module id = 247
// module chunks = 0